module.exports = __webpack_public_path__ + "img/LOGO_2162_1_2.ba34ab32.svg";